/**
 * Identifies HTTP statuses eligible for chunk retry: 408, 429 and the inclusive 500–599 range.
 * Postconditions: Every other status returns false; network failures are handled by the uploader.
 */
export const isRetryableChunkUploadStatus = (status: number): boolean =>
    status === 408 || status === 429 || (status >= 500 && status <= 599);
